import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function useSettings() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setSettings(r.data || {}))
      .catch(() => {});
  }, []);
  return settings;
}
